export default {
    apiKey: "AIzaSyDiNHu3r3X9BC5D56NAeHicvonUXIwEp7E",
    authDomain: "payments-live-41ffd.firebaseapp.com",
    databaseURL: "https://payments-live-41ffd.firebaseio.com",
    projectId: "payments-live-41ffd",
    storageBucket: "payments-live-41ffd.appspot.com",
    messagingSenderId: "834524341219",
    appId: "1:834524341219:web:f75b9759a4b527909a76d6",
    measurementId: "G-3XMH37826C"
}
